var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-slider"},[_c('transition-group',{staticClass:"transition-container",attrs:{"name":"slide-right fade","tag":"div"}},_vm._l(([_vm.currentIndex]),function(i){return _c('div',{key:i,staticClass:"img-slide"},[_c('img',{attrs:{"src":_vm.currentImg}})])}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ee98ce1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ImageSlider.vue
// module id = null
// module chunks = 